module.exports = __webpack_public_path__ + "static/img/icon.768dd62.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1st/Articles/Article_2/icon.jpg
// module id = pzyj
// module chunks = 0